module.exports = __webpack_public_path__ + "img/1522308775.b084d72e.jpg";